import { z } from 'zod'
import { COUNTRY_CODES } from '@/config/billing'
import { isValidCanadianProvinceCode, isValidStateCode } from '@/lib/utils'

export const billingDetailsSchema = z
  .object({
    country: z.string().nonempty({ message: 'Country is required' }),
    timezone: z.string().optional(),
    state: z.string().nonempty({ message: 'State/Province is required' }),
    city: z.string().nonempty({ message: 'City is required' }),
    zip: z.string().nonempty({ message: 'ZIP/Postal Code is required' }),
    street: z.string().nonempty({ message: 'Address line 1 is required' }),
    street2: z.string().optional(),
    name: z
      .string()
      .regex(/^[\p{L}\p{N}\p{P}\p{Z}]+$/u, {
        message: 'Invalid character in name',
      })
      .nonempty({ message: 'Name is required' }),
  })
  .refine(
    (data) => {
      if (!data.state || !data.country) return true

      if (data.country === COUNTRY_CODES.US) {
        return isValidStateCode(data.state)
      }
      if (data.country === COUNTRY_CODES.CA) {
        return isValidCanadianProvinceCode(data.state)
      }
      return true
    },
    {
      message: 'Invalid state/province code for selected country',
      path: ['state'],
    }
  )
